module.exports = __webpack_public_path__ + "files/SPIADI2022 - PRÉVENTION DES INFECTIONS LIÉES À UN CATHÉTER.bcd4f050d9c25ea0f9af5df428fc67d2.pdf";